import React from 'react'
import SelectField from '../CheckboxSelectField'
import StartLabelField from './StartLabelField'
import type { CheckboxSelectFieldProps } from '../CheckboxSelectField'

type Props = CheckboxSelectFieldProps & {
    label: string
}

/**
 *  Must be in the grid container to display properly
 * */
export const StartLabelCheckboxSelectField: React.VFC<Props> = ({ name, label, ...fieldProps }: Props) => {
    return (
        <StartLabelField name={name} label={label}>
            <SelectField name={name} {...fieldProps} />
        </StartLabelField>
    )
}

export default StartLabelCheckboxSelectField
export type { Props as StartLabelCheckboxSelectFieldProps }
